angular.module('app').directive('apSavePdfToFile',
    ['BrowserService',
        function (BrowserService) {
            'use strict';

            function link($scope, element) {
                function _savePdfAsFile(fileNameToSaveAs, base64String, contentType) {

                    if (!BrowserService.isBlobCompatible) {
                        return;
                    }

                    var byteCharacters = atob(base64String);
                    var byteArray = new Array(byteCharacters.length);

                    for (var i = 0; i < byteCharacters.length; i++) {
                        byteArray[i] = byteCharacters.charCodeAt(i);
                    }
                    var byteArrayInt = new Uint8Array(byteArray);


                    var textFileAsBlob = new Blob([byteArrayInt], {
                        type: contentType
                    });

                    BrowserService.saveBlob(document, textFileAsBlob, fileNameToSaveAs);

                }

                function _onClick() {
                    _savePdfAsFile($scope.fileName, $scope.base64String, $scope.contentType);
                }

                element.on('click', _onClick);
                $scope.$on('$destroy', function () {
                    element.off('click');
                });
            }

            return {
                restrict: 'A',
                scope: {
                    base64String: '@apSavePdfToFile',
                    contentType: '@',
                    fileName: '@'
                },
                link: link
            };
        }]);